// extracted by mini-css-extract-plugin
export default {"root":"Nav_root__Yq9ee","on":"Nav_on__aCxXb","label":"Nav_label__3qkC4","button":"Nav_button__JPu6X"};